import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AscLogo from './AscLogo';
import LanguageSelector from './LanguageSelector';
import { login, register } from '../services/auth';
import './LoginScreen.css';

export default function LoginScreen({ onLogin }) {
  const { t } = useTranslation();
  const [mode, setMode]       = useState('login');
  const [username, setUser]   = useState('');
  const [password, setPass]   = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');

  const submit = async () => {
    if (!username || !password) { setError(t('login.fill_fields')); return; }
    setLoading(true); setError(''); setSuccess('');
    try {
      if (mode === 'login') {
        await login(username, password);
        window.location.reload(); // hooks re-inizializzano con token in localStorage
      } else {
        const data = await register(username, password);
        setSuccess(data.message);
        setMode('login');
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleKey = e => { if (e.key === 'Enter') submit(); };

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-lang-sel">
          <LanguageSelector />
        </div>
        <div className="login-logo">
          <AscLogo size={56}/>
        </div>
        <div className="login-title">SIRUS <span>ASSISTANT</span></div>
        <div className="login-sub">
          {mode === 'login' ? t('login.title') : t('login.register_title')}
        </div>

        <div className="login-form">
          <div className="login-field">
            <div className="field-lbl">{t('login.username')}</div>
            <input
              className="login-inp"
              type="text"
              placeholder="username..."
              value={username}
              onChange={e => setUser(e.target.value)}
              onKeyDown={handleKey}
              autoComplete="username"
            />
          </div>
          <div className="login-field">
            <div className="field-lbl">{t('login.password')}</div>
            <input
              className="login-inp"
              type="password"
              placeholder="password..."
              value={password}
              onChange={e => setPass(e.target.value)}
              onKeyDown={handleKey}
              autoComplete="current-password"
            />
          </div>

          {error   && <div className="login-err">⚠ {error}</div>}
          {success && <div className="login-ok">✓ {success}</div>}

          <button className="login-btn" onClick={submit} disabled={loading}>
            {loading ? t('login.loading')
              : mode === 'login' ? t('login.submit_login') : t('login.submit_register')}
          </button>

          <div className="login-switch">
            {mode === 'login'
              ? <>{t('login.switch_register')}<span onClick={() => { setMode('register'); setError(''); }}>{t('login.register_link')}</span></>
              : <>{t('login.switch_login')}<span onClick={() => { setMode('login'); setError(''); }}>{t('login.login_link')}</span></>
            }
          </div>
        </div>
      </div>
    </div>
  );
}
